export default function byEntity1CardinalityAndEntity2(a,b) {
    debugger
    // First, compare by entity1
    if (a.from < b.from) return -1;
    if (a.from > b.from) return 1;
    
    // If entity1 is the same, compare by cardinality
    const cardinalityOrder = { "one-to-many": 0, "one-to-one": 1, "many-to-many": 2 };
    const aCardinalityOrder = cardinalityOrder[a.cardinality];
    const bCardinalityOrder = cardinalityOrder[b.cardinality];
    if (aCardinalityOrder < bCardinalityOrder) return -1;
    if (aCardinalityOrder > bCardinalityOrder) return 1;
    
    // If entity1 and cardinality are the same, compare by entity2
    if (a.to < b.to) return -1;
    if (a.to > b.to) return 1;
    
    // If all three fields are the same, leave them in their current order
    return 0;
}